// extracted by mini-css-extract-plugin
export default {"wrapper":"MaterielManagement_wrapper__cqu9I"};